import createIcon from '../../createIcon';

/**
 * @component @name HomeRepairService
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgOEgxN1Y2QzE3IDQuOSAxNi4xIDQgMTUgNEg5QzcuOSA0IDcgNC45IDcgNlY4SDRDMi45IDggMiA4LjkgMiAxMFYyMEgyMlYxMEMyMiA4LjkgMjEuMSA4IDIwIDhaTTkgNkgxNVY4SDlWNlpNMjAgMThINFYxNUg2VjE2SDhWMTVIMTZWMTZIMThWMTVIMjBWMThaTTE4IDEzVjEySDE2VjEzSDhWMTJINlYxM0g0VjEwSDIwVjEzSDE4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HomeRepairService = createIcon('HomeRepairService', [
  [
    'path',
    {
      d: 'M20 8H17V6C17 4.9 16.1 4 15 4H9C7.9 4 7 4.9 7 6V8H4C2.9 8 2 8.9 2 10V20H22V10C22 8.9 21.1 8 20 8ZM9 6H15V8H9V6ZM20 18H4V15H6V16H8V15H16V16H18V15H20V18ZM18 13V12H16V13H8V12H6V13H4V10H20V13H18Z',
      key: '1c84nu',
    },
  ],
]);

export default HomeRepairService;
